module.exports = __webpack_public_path__ + "static/ISO_9001_2015_Standards_Logo-7e3e1bb9e25b9ed8741892f745f4f575.png";